import { BASE, CATALYST, ELEMENT, SPEC_MAIN, TYPE } from '../enum';

export const productsBasic = [
	{
		id: 40000,
		name: 'Alchemic Food (Red)',
		type: TYPE.FOOD,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.FOOD, TYPE.FOOD, TYPE.FOOD, TYPE.FOOD],
	},
	{
		id: 40001,
		name: 'Alchemic Food (Green)',
		type: TYPE.FOOD,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.FOOD, TYPE.FOOD, TYPE.WOOD, TYPE.FOOD],
	},
	{
		id: 40002,
		name: 'Alchemic Food (White)',
		type: TYPE.FOOD,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.AIR,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.FOOD, TYPE.WOOD, TYPE.FOOD, TYPE.WOOD],
	},
	{
		id: 40003,
		name: 'Alchemic Food (Blue)',
		type: TYPE.FOOD,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.WATER,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.FOOD, TYPE.WOOD, TYPE.WOOD, TYPE.FOOD],
	},
	{
		id: 40024,
		name: 'Charming Potion',
		type: TYPE.POISON,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.RED_GEMSTONE,
		recipe: [TYPE.FOOD, TYPE.FOOD, TYPE.WOOD, TYPE.BEAST],
	},
	{
		id: 40025,
		name: 'Alchemic Antidote',
		type: TYPE.POISON,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.RED_GEMSTONE,
		recipe: [TYPE.FOOD, TYPE.SAND, TYPE.ALLOY, TYPE.MAGIC],
	},
	{
		id: 40026,
		name: 'Pesticide Kit',
		type: TYPE.POISON,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.AIR,
		catalyst: CATALYST.RED_GEMSTONE,
		recipe: [TYPE.FOOD, TYPE.SAND, TYPE.WOOD, TYPE.FOOD],
	},
	{
		id: 40027,
		name: 'Demon Blood',
		type: TYPE.POISON,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.WATER,
		catalyst: CATALYST.RED_GEMSTONE,
		recipe: [TYPE.FOOD, TYPE.BEAST, TYPE.BEAST, TYPE.WOOD],
	},
	{
		id: 40028,
		name: 'Basic Potion',
		type: TYPE.HEAL,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.CYFAR,
		recipe: [TYPE.FOOD, TYPE.FOOD, TYPE.FOOD, TYPE.FOOD],
	},
	{
		id: 40029,
		name: 'Royal Black Tea',
		type: TYPE.HEAL,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.CYFAR,
		recipe: [TYPE.FOOD, TYPE.SAND, TYPE.SAND, TYPE.SAND],
	},
	{
		id: 40030,
		name: 'Jelly Potion',
		type: TYPE.HEAL,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.AIR,
		catalyst: CATALYST.CYFAR,
		recipe: [TYPE.FOOD, TYPE.SAND, TYPE.WOOD, TYPE.FOOD],
	},
	{
		id: 40031,
		name: 'Psychic Potion',
		type: TYPE.HEAL,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.WATER,
		catalyst: CATALYST.CYFAR,
		recipe: [TYPE.FOOD, TYPE.WOOD, TYPE.FOOD, TYPE.FOOD],
	},
	{
		id: 40032,
		name: 'Power Tonic',
		type: TYPE.TONIC,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.YELLOW_GEMSTONE,
		recipe: [TYPE.FOOD, TYPE.BEAST, TYPE.WOOD, TYPE.BEAST],
	},
	{
		id: 40033,
		name: 'Vigor Tonic',
		type: TYPE.TONIC,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.YELLOW_GEMSTONE,
		recipe: [TYPE.FOOD, TYPE.FOOD, TYPE.SAND, TYPE.BEAST],
	},
	{
		id: 40034,
		name: 'Accerelation Tonic',
		type: TYPE.TONIC,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.AIR,
		catalyst: CATALYST.YELLOW_GEMSTONE,
		recipe: [TYPE.FOOD, TYPE.BEAST, TYPE.BEAST, TYPE.BEAST],
	},
	{
		id: 40035,
		name: 'Magic Tonic',
		type: TYPE.TONIC,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.WATER,
		catalyst: CATALYST.YELLOW_GEMSTONE,
		recipe: [TYPE.FOOD, TYPE.WOOD, TYPE.MAGIC, TYPE.FOOD],
	},
	{
		id: 40036,
		name: 'Pepper X Sauce',
		type: TYPE.CONDIMENT,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.BLUE_GEMSTONE,
		recipe: [TYPE.FOOD, TYPE.FOOD, TYPE.SAND, TYPE.BEAST],
	},
	{
		id: 40037,
		name: 'Ajvar',
		type: TYPE.CONDIMENT,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.BLUE_GEMSTONE,
		recipe: [TYPE.FOOD, TYPE.FOOD, TYPE.SAND, TYPE.SAND],
	},
	{
		id: 40038,
		name: 'Preserved Lemon',
		type: TYPE.CONDIMENT,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.AIR,
		catalyst: CATALYST.BLUE_GEMSTONE,
		recipe: [TYPE.FOOD, TYPE.SAND, TYPE.ALLOY, TYPE.WOOD],
	},
	{
		id: 40039,
		name: 'Grape Jam',
		type: TYPE.CONDIMENT,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.WATER,
		catalyst: CATALYST.BLUE_GEMSTONE,
		recipe: [TYPE.FOOD, TYPE.FOOD, TYPE.FOOD, TYPE.MAGIC],
	},
	{
		id: 40004,
		name: 'Everdry Plant',
		type: TYPE.WOOD,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.WOOD, TYPE.FOOD, TYPE.FOOD, TYPE.WOOD],
	},
	{
		id: 40005,
		name: 'Tea Plant',
		type: TYPE.WOOD,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.WOOD, TYPE.FOOD, TYPE.WOOD, TYPE.WOOD],
	},
	{
		id: 40006,
		name: 'Fragrant Plant',
		type: TYPE.WOOD,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.AIR,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.WOOD, TYPE.WOOD, TYPE.FOOD, TYPE.FOOD],
	},
	{
		id: 40007,
		name: 'Poisonous Plant',
		type: TYPE.WOOD,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.WATER,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.WOOD, TYPE.FOOD, TYPE.WOOD, TYPE.FOOD],
	},
	{
		id: 40040,
		name: 'Everlasting Fuel',
		type: TYPE.FUEL,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.RED_GEMSTONE,
		recipe: [TYPE.WOOD, TYPE.BEAST, TYPE.FOOD, TYPE.BEAST],
	},
	{
		id: 40041,
		name: 'Black Gold',
		type: TYPE.FUEL,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.RED_GEMSTONE,
		recipe: [TYPE.WOOD, TYPE.SAND, TYPE.BEAST, TYPE.SAND],
	},
	{
		id: 40042,
		name: 'Flammable Gas',
		type: TYPE.FUEL,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.AIR,
		catalyst: CATALYST.RED_GEMSTONE,
		recipe: [TYPE.WOOD, TYPE.BEAST, TYPE.FOOD, TYPE.WOOD],
	},
	{
		id: 40043,
		name: 'Synthetic Oil',
		type: TYPE.FUEL,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.WATER,
		catalyst: CATALYST.RED_GEMSTONE,
		recipe: [TYPE.WOOD, TYPE.SAND, TYPE.BEAST, TYPE.WOOD],
	},
	{
		id: 40044,
		name: 'Magenta Pigment',
		type: TYPE.DYE,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.CYFAR,
		recipe: [TYPE.WOOD, TYPE.FOOD, TYPE.SAND, TYPE.MAGIC],
	},
	{
		id: 40045,
		name: 'Shade Pigment',
		type: TYPE.DYE,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.CYFAR,
		recipe: [TYPE.WOOD, TYPE.FOOD, TYPE.SAND, TYPE.ALLOY],
	},
	{
		id: 40046,
		name: 'Yellow Pigment',
		type: TYPE.DYE,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.AIR,
		catalyst: CATALYST.CYFAR,
		recipe: [TYPE.WOOD, TYPE.FOOD, TYPE.SAND, TYPE.SAND],
	},
	{
		id: 40047,
		name: 'Cyan Pigment',
		type: TYPE.DYE,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.WATER,
		catalyst: CATALYST.CYFAR,
		recipe: [TYPE.WOOD, TYPE.FOOD, TYPE.SAND, TYPE.BEAST],
	},
	{
		id: 40048,
		name: 'Alchemist\'s Hammer',
		type: TYPE.TOOL,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.YELLOW_GEMSTONE,
		recipe: [TYPE.WOOD, TYPE.SAND, TYPE.BEAST, TYPE.FOOD],
	},
	{
		id: 40049,
		name: 'Sand Shovel',
		type: TYPE.TOOL,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.YELLOW_GEMSTONE,
		recipe: [TYPE.WOOD, TYPE.WOOD, TYPE.FOOD, TYPE.WOOD],
	},
	{
		id: 40050,
		name: 'Scouter',
		type: TYPE.TOOL,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.AIR,
		catalyst: CATALYST.YELLOW_GEMSTONE,
		recipe: [TYPE.WOOD, TYPE.WOOD, TYPE.SAND, TYPE.WOOD],
	},
	{
		id: 40051,
		name: 'Alchemist\'s Grimoire',
		type: TYPE.TOOL,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.WATER,
		catalyst: CATALYST.YELLOW_GEMSTONE,
		recipe: [TYPE.WOOD, TYPE.BEAST, TYPE.ALLOY, TYPE.SAND],
	},
	{
		id: 40052,
		name: 'Baking Sheet Paper',
		type: TYPE.PAPER,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.BLUE_GEMSTONE,
		recipe: [TYPE.WOOD, TYPE.FOOD, TYPE.SAND, TYPE.FOOD],
	},
	{
		id: 40053,
		name: 'High Quality Paper',
		type: TYPE.PAPER,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.BLUE_GEMSTONE,
		recipe: [TYPE.WOOD, TYPE.WOOD, TYPE.WOOD, TYPE.FOOD],
	},
	{
		id: 40054,
		name: 'Decorative Paper',
		type: TYPE.PAPER,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.AIR,
		catalyst: CATALYST.BLUE_GEMSTONE,
		recipe: [TYPE.WOOD, TYPE.BEAST, TYPE.WOOD, TYPE.WOOD],
	},
	{
		id: 40055,
		name: 'Enchanted Paper',
		type: TYPE.PAPER,
		minQuality: 0,
		minScore: 0,
		base: BASE.CONCENTRATION,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.WATER,
		catalyst: CATALYST.BLUE_GEMSTONE,
		recipe: [TYPE.WOOD, TYPE.SAND, TYPE.MAGIC, TYPE.WOOD],
	},
];

export const productsIntermediate = [
	{
		id: 40008,
		name: 'Warmth Powder',
		type: TYPE.SAND,
		minQuality: 35,
		minScore: 0,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.SAND, TYPE.BEAST, TYPE.WOOD, TYPE.WOOD],
	},
	{
		id: 40009,
		name: 'Refined Powder',
		type: TYPE.SAND,
		minQuality: 35,
		minScore: 0,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.SAND, TYPE.SAND, TYPE.WOOD, TYPE.WOOD],
	},
	{
		id: 40010,
		name: 'Aromatic Powder',
		type: TYPE.SAND,
		minQuality: 35,
		minScore: 0,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.AIR,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.SAND, TYPE.FOOD, TYPE.FOOD, TYPE.BEAST],
	},
	{
		id: 40011,
		name: 'Chilling Powder',
		type: TYPE.SAND,
		minQuality: 35,
		minScore: 0,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.WATER,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.SAND, TYPE.FOOD, TYPE.WOOD, TYPE.FOOD],
	},
	{
		id: 40056,
		name: 'Fire Stone',
		type: TYPE.ELEMENTAL,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.RED_GEMSTONE,
		recipe: [TYPE.SAND, TYPE.MAGIC, TYPE.FOOD, TYPE.WOOD],
	},
	{
		id: 40057,
		name: 'Leaf Stone',
		type: TYPE.ELEMENTAL,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.RED_GEMSTONE,
		recipe: [TYPE.SAND, TYPE.ALLOY, TYPE.BEAST, TYPE.ALLOY],
	},
	{
		id: 40058,
		name: 'Thunder Stone',
		type: TYPE.ELEMENTAL,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.AIR,
		catalyst: CATALYST.RED_GEMSTONE,
		recipe: [TYPE.SAND, TYPE.BEAST, TYPE.WOOD, TYPE.WOOD],
	},
	{
		id: 40059,
		name: 'Water Stone',
		type: TYPE.ELEMENTAL,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.WATER,
		catalyst: CATALYST.RED_GEMSTONE,
		recipe: [TYPE.SAND, TYPE.MAGIC, TYPE.MAGIC, TYPE.MAGIC],
	},
	{
		id: 40060,
		name: 'Charged Ore',
		type: TYPE.REFINE,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.CYFAR,
		recipe: [TYPE.SAND, TYPE.WOOD, TYPE.BEAST, TYPE.FOOD],
	},
	{
		id: 40061,
		name: 'Shade Ore',
		type: TYPE.REFINE,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.CYFAR,
		recipe: [TYPE.SAND, TYPE.SAND, TYPE.WOOD, TYPE.MAGIC],
	},
	{
		id: 40062,
		name: 'Crystal Ore',
		type: TYPE.REFINE,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.AIR,
		catalyst: CATALYST.CYFAR,
		recipe: [TYPE.SAND, TYPE.ALLOY, TYPE.WOOD, TYPE.WOOD],
	},
	{
		id: 40063,
		name: 'Energy Ore',
		type: TYPE.REFINE,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.WATER,
		catalyst: CATALYST.CYFAR,
		recipe: [TYPE.SAND, TYPE.WOOD, TYPE.MAGIC, TYPE.MAGIC],
	},
	{
		id: 40064,
		name: 'Crimson Maxima',
		type: TYPE.CRYSTAL,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.YELLOW_GEMSTONE,
		recipe: [TYPE.SAND, TYPE.ALLOY, TYPE.WOOD, TYPE.BEAST],
	},
	{
		id: 40065,
		name: 'Nature Maxima',
		type: TYPE.CRYSTAL,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.YELLOW_GEMSTONE,
		recipe: [TYPE.SAND, TYPE.SAND, TYPE.ALLOY, TYPE.WOOD],
	},
	{
		id: 40066,
		name: 'Prism Maxima',
		type: TYPE.CRYSTAL,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.AIR,
		catalyst: CATALYST.YELLOW_GEMSTONE,
		recipe: [TYPE.SAND, TYPE.BEAST, TYPE.FOOD, TYPE.MAGIC],
	},
	{
		id: 40067,
		name: 'Mana Maxima',
		type: TYPE.CRYSTAL,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.WATER,
		catalyst: CATALYST.YELLOW_GEMSTONE,
		recipe: [TYPE.SAND, TYPE.FOOD, TYPE.SAND, TYPE.MAGIC],
	},
	{
		id: 40068,
		name: 'Hard Paste Porcelain',
		type: TYPE.PORCELAIN,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.BLUE_GEMSTONE,
		recipe: [TYPE.SAND, TYPE.SAND, TYPE.FOOD, TYPE.ALLOY],
	},
	{
		id: 40069,
		name: 'Glass Bottle',
		type: TYPE.PORCELAIN,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.BLUE_GEMSTONE,
		recipe: [TYPE.SAND, TYPE.SAND, TYPE.FOOD, TYPE.MAGIC],
	},
	{
		id: 40070,
		name: 'Pottering',
		type: TYPE.PORCELAIN,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.AIR,
		catalyst: CATALYST.BLUE_GEMSTONE,
		recipe: [TYPE.SAND, TYPE.SAND, TYPE.BEAST, TYPE.BEAST],
	},
	{
		id: 40071,
		name: 'Heat Resistant Cookpot',
		type: TYPE.PORCELAIN,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.WATER,
		catalyst: CATALYST.BLUE_GEMSTONE,
		recipe: [TYPE.SAND, TYPE.SAND, TYPE.SAND, TYPE.SAND],
	},
	{
		id: 40012,
		name: 'Magmaring Spark',
		type: TYPE.BEAST,
		minQuality: 35,
		minScore: 0,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.BEAST, TYPE.WOOD, TYPE.FOOD, TYPE.WOOD],
	},
	{
		id: 40013,
		name: 'Stapo Spark',
		type: TYPE.BEAST,
		minQuality: 35,
		minScore: 0,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.BEAST, TYPE.SAND, TYPE.SAND, TYPE.SAND],
	},
	{
		id: 40014,
		name: 'Poporing Spark',
		type: TYPE.BEAST,
		minQuality: 35,
		minScore: 0,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.AIR,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.BEAST, TYPE.BEAST, TYPE.BEAST, TYPE.BEAST],
	},
	{
		id: 40015,
		name: 'Pouring Spark',
		type: TYPE.BEAST,
		minQuality: 35,
		minScore: 0,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.WATER,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.BEAST, TYPE.FOOD, TYPE.WOOD, TYPE.SAND],
	},
	{
		id: 40072,
		name: 'Banana Explosive',
		type: TYPE.BOMB,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.RED_GEMSTONE,
		recipe: [TYPE.BEAST, TYPE.SAND, TYPE.WOOD, TYPE.FOOD],
	},
	{
		id: 40073,
		name: 'Coconut Grenade',
		type: TYPE.BOMB,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.RED_GEMSTONE,
		recipe: [TYPE.BEAST, TYPE.ALLOY, TYPE.FOOD, TYPE.WOOD],
	},
	{
		id: 40074,
		name: 'Uni Buster!',
		type: TYPE.BOMB,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.AIR,
		catalyst: CATALYST.RED_GEMSTONE,
		recipe: [TYPE.BEAST, TYPE.ALLOY, TYPE.ALLOY, TYPE.ALLOY],
	},
	{
		id: 40075,
		name: 'Melon Spike',
		type: TYPE.BOMB,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.WATER,
		catalyst: CATALYST.RED_GEMSTONE,
		recipe: [TYPE.BEAST, TYPE.FOOD, TYPE.WOOD, TYPE.ALLOY],
	},
	{
		id: 40076,
		name: 'Red Fertilizer',
		type: TYPE.FERTILIZER,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.CYFAR,
		recipe: [TYPE.BEAST, TYPE.BEAST, TYPE.WOOD, TYPE.BEAST],
	},
	{
		id: 40077,
		name: 'Green Fertilizer',
		type: TYPE.FERTILIZER,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.CYFAR,
		recipe: [TYPE.BEAST, TYPE.BEAST, TYPE.ALLOY, TYPE.BEAST],
	},
	{
		id: 40078,
		name: 'Yellow Fertilizer',
		type: TYPE.FERTILIZER,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.AIR,
		catalyst: CATALYST.CYFAR,
		recipe: [TYPE.BEAST, TYPE.BEAST, TYPE.SAND, TYPE.BEAST],
	},
	{
		id: 40079,
		name: 'Blue Fertilizer',
		type: TYPE.FERTILIZER,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.WATER,
		catalyst: CATALYST.CYFAR,
		recipe: [TYPE.BEAST, TYPE.BEAST, TYPE.MAGIC, TYPE.BEAST],
	},
	{
		id: 40080,
		name: 'Ifrit\'s Essence',
		type: TYPE.ESSENCE,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.YELLOW_GEMSTONE,
		recipe: [TYPE.BEAST, TYPE.BEAST, TYPE.FOOD, TYPE.WOOD],
	},
	{
		id: 40081,
		name: 'Maya\'s Essence',
		type: TYPE.ESSENCE,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.YELLOW_GEMSTONE,
		recipe: [TYPE.BEAST, TYPE.SAND, TYPE.WOOD, TYPE.SAND],
	},
	{
		id: 40082,
		name: 'Mistress\' Essence',
		type: TYPE.ESSENCE,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.AIR,
		catalyst: CATALYST.YELLOW_GEMSTONE,
		recipe: [TYPE.BEAST, TYPE.FOOD, TYPE.BEAST, TYPE.MAGIC],
	},
	{
		id: 40083,
		name: 'Garm\'s Essence',
		type: TYPE.ESSENCE,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.WATER,
		catalyst: CATALYST.YELLOW_GEMSTONE,
		recipe: [TYPE.BEAST, TYPE.BEAST, TYPE.SAND, TYPE.WOOD],
	},
	{
		id: 40084,
		name: 'Valkyrie Blessing',
		type: TYPE.TALISMAN,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.BLUE_GEMSTONE,
		recipe: [TYPE.BEAST, TYPE.ALLOY, TYPE.ALLOY, TYPE.WOOD],
	},
	{
		id: 40085,
		name: 'Evil Repel Badge',
		type: TYPE.TALISMAN,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.BLUE_GEMSTONE,
		recipe: [TYPE.BEAST, TYPE.WOOD, TYPE.ALLOY, TYPE.MAGIC],
	},
	{
		id: 40086,
		name: 'Prosperity Charm',
		type: TYPE.TALISMAN,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.AIR,
		catalyst: CATALYST.BLUE_GEMSTONE,
		recipe: [TYPE.BEAST, TYPE.MAGIC, TYPE.SAND, TYPE.ALLOY],
	},
	{
		id: 40087,
		name: 'Siren\'s Tear',
		type: TYPE.TALISMAN,
		minQuality: 45,
		minScore: 300,
		base: BASE.AWAKENING,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.WATER,
		catalyst: CATALYST.BLUE_GEMSTONE,
		recipe: [TYPE.BEAST, TYPE.MAGIC, TYPE.BEAST, TYPE.MAGIC],
	},
];

export const productsAdvanced = [
	{
		id: 40016,
		name: 'Precious Steel',
		type: TYPE.ALLOY,
		minQuality: 55,
		minScore: 0,
		base: BASE.BERSERK,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.ALLOY, TYPE.SAND, TYPE.WOOD, TYPE.ALLOY],
	},
	{
		id: 40017,
		name: 'Fusion Alloy',
		type: TYPE.ALLOY,
		minQuality: 55,
		minScore: 0,
		base: BASE.BERSERK,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.ALLOY, TYPE.MAGIC, TYPE.SAND, TYPE.FOOD],
	},
	{
		id: 40018,
		name: 'Metallic Gas',
		type: TYPE.ALLOY,
		minQuality: 55,
		minScore: 0,
		base: BASE.BERSERK,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.AIR,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.ALLOY, TYPE.BEAST, TYPE.ALLOY, TYPE.WOOD],
	},
	{
		id: 40019,
		name: 'Quicksilver',
		type: TYPE.ALLOY,
		minQuality: 55,
		minScore: 0,
		base: BASE.BERSERK,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.WATER,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.ALLOY, TYPE.FOOD, TYPE.BEAST, TYPE.MAGIC],
	},
	{
		id: 40088,
		name: 'Soul Eater',
		type: TYPE.WEAPON,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40016,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.IFRIT_ESSENCE,
		recipe: [TYPE.ALLOY, TYPE.WOOD, TYPE.ALLOY, TYPE.MAGIC],
	},
	{
		id: 40089,
		name: 'Meteor Hammer',
		type: TYPE.WEAPON,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40017,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.IFRIT_ESSENCE,
		recipe: [TYPE.ALLOY, TYPE.SAND, TYPE.WOOD, TYPE.SAND],
	},
	{
		id: 40090,
		name: 'Ridewind',
		type: TYPE.WEAPON,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40018,
		element: ELEMENT.AIR,
		catalyst: CATALYST.IFRIT_ESSENCE,
		recipe: [TYPE.ALLOY, TYPE.BEAST, TYPE.WOOD, TYPE.WOOD],
	},
	{
		id: 40091,
		name: 'Alkahest',
		type: TYPE.WEAPON,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40019,
		element: ELEMENT.WATER,
		catalyst: CATALYST.IFRIT_ESSENCE,
		recipe: [TYPE.ALLOY, TYPE.MAGIC, TYPE.ALLOY, TYPE.MAGIC],
	},
	{
		id: 40092,
		name: 'Fierce Heavy Armor',
		type: TYPE.ARMOR,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40016,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.MAYA_ESSENCE,
		recipe: [TYPE.ALLOY, TYPE.WOOD, TYPE.ALLOY, TYPE.FOOD],
	},
	{
		id: 40093,
		name: 'Cracking Heavy Armor',
		type: TYPE.ARMOR,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40017,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.MAYA_ESSENCE,
		recipe: [TYPE.ALLOY, TYPE.SAND, TYPE.ALLOY, TYPE.SAND],
	},
	{
		id: 40094,
		name: 'Raging Heavy Armor',
		type: TYPE.ARMOR,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40018,
		element: ELEMENT.AIR,
		catalyst: CATALYST.MAYA_ESSENCE,
		recipe: [TYPE.ALLOY, TYPE.BEAST, TYPE.ALLOY, TYPE.BEAST],
	},
	{
		id: 40095,
		name: 'Stormy Heavy Armor',
		type: TYPE.ARMOR,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40019,
		element: ELEMENT.WATER,
		catalyst: CATALYST.MAYA_ESSENCE,
		recipe: [TYPE.ALLOY, TYPE.MAGIC, TYPE.ALLOY, TYPE.MAGIC],
	},
	{
		id: 40096,
		name: 'Warrior\'s Blessing',
		type: TYPE.HEADGEAR,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40016,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.MISTRESS_ESSENCE,
		recipe: [TYPE.ALLOY, TYPE.ALLOY, TYPE.MAGIC, TYPE.BEAST],
	},
	{
		id: 40097,
		name: 'Crystalline Helmet',
		type: TYPE.HEADGEAR,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40017,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.MISTRESS_ESSENCE,
		recipe: [TYPE.ALLOY, TYPE.ALLOY, TYPE.SAND, TYPE.MAGIC],
	},
	{
		id: 40098,
		name: 'Crown of Ragnanival',
		type: TYPE.HEADGEAR,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40018,
		element: ELEMENT.AIR,
		catalyst: CATALYST.MISTRESS_ESSENCE,
		recipe: [TYPE.ALLOY, TYPE.ALLOY, TYPE.MAGIC, TYPE.WOOD],
	},
	{
		id: 40099,
		name: 'Ceremonial Headpiece',
		type: TYPE.HEADGEAR,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40019,
		element: ELEMENT.WATER,
		catalyst: CATALYST.MISTRESS_ESSENCE,
		recipe: [TYPE.ALLOY, TYPE.ALLOY, TYPE.FOOD, TYPE.MAGIC],
	},
	{
		id: 40100,
		name: 'Retribution Shield',
		type: TYPE.SHIELD,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40016,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.GARM_ESSENCE,
		recipe: [TYPE.ALLOY, TYPE.ALLOY, TYPE.ALLOY, TYPE.ALLOY],
	},
	{
		id: 40101,
		name: 'Shield of Regen',
		type: TYPE.SHIELD,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40017,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.GARM_ESSENCE,
		recipe: [TYPE.ALLOY, TYPE.FOOD, TYPE.ALLOY, TYPE.SAND],
	},
	{
		id: 40102,
		name: 'Razor Shield',
		type: TYPE.SHIELD,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40018,
		element: ELEMENT.AIR,
		catalyst: CATALYST.GARM_ESSENCE,
		recipe: [TYPE.ALLOY, TYPE.ALLOY, TYPE.SAND, TYPE.MAGIC],
	},
	{
		id: 40103,
		name: 'Hex Breaker',
		type: TYPE.SHIELD,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40019,
		element: ELEMENT.WATER,
		catalyst: CATALYST.GARM_ESSENCE,
		recipe: [TYPE.ALLOY, TYPE.MAGIC, TYPE.ALLOY, TYPE.MAGIC],
	},
	{
		id: 40020,
		name: 'Fire Core',
		type: TYPE.MAGIC,
		minQuality: 55,
		minScore: 0,
		base: BASE.BERSERK,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.MAGIC, TYPE.MAGIC, TYPE.WOOD, TYPE.BEAST],
	},
	{
		id: 40021,
		name: 'Earth Core',
		type: TYPE.MAGIC,
		minQuality: 55,
		minScore: 0,
		base: BASE.BERSERK,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.MAGIC, TYPE.FOOD, TYPE.SAND, TYPE.ALLOY],
	},
	{
		id: 40022,
		name: 'Air Core',
		type: TYPE.MAGIC,
		minQuality: 55,
		minScore: 0,
		base: BASE.BERSERK,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.AIR,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.MAGIC, TYPE.WOOD, TYPE.MAGIC, TYPE.BEAST],
	},
	{
		id: 40023,
		name: 'Water Core',
		type: TYPE.MAGIC,
		minQuality: 55,
		minScore: 0,
		base: BASE.BERSERK,
		specificMain: SPEC_MAIN.NONE,
		element: ELEMENT.WATER,
		catalyst: CATALYST.NONE,
		recipe: [TYPE.MAGIC, TYPE.ALLOY, TYPE.FOOD, TYPE.SAND],
	},
	{
		id: 40104,
		name: 'Level 1 Fire Bolt',
		type: TYPE.BOLT,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40020,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.IFRIT_ESSENCE,
		recipe: [TYPE.MAGIC, TYPE.FOOD, TYPE.FOOD, TYPE.MAGIC],
	},
	{
		id: 40105,
		name: 'Level 1 Earth Spike',
		type: TYPE.BOLT,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40020,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.IFRIT_ESSENCE,
		recipe: [TYPE.MAGIC, TYPE.WOOD, TYPE.WOOD, TYPE.MAGIC],
	},
	{
		id: 40106,
		name: 'Level 1 Lightning Bolt',
		type: TYPE.BOLT,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40020,
		element: ELEMENT.AIR,
		catalyst: CATALYST.IFRIT_ESSENCE,
		recipe: [TYPE.MAGIC, TYPE.ALLOY, TYPE.ALLOY, TYPE.MAGIC],
	},
	{
		id: 40107,
		name: 'Level 1 Cold Bolt',
		type: TYPE.BOLT,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40020,
		element: ELEMENT.WATER,
		catalyst: CATALYST.IFRIT_ESSENCE,
		recipe: [TYPE.MAGIC, TYPE.BEAST, TYPE.BEAST, TYPE.MAGIC],
	},
	{
		id: 40108,
		name: 'Stun Recovery',
		type: TYPE.RECOVERY,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40021,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.MAYA_ESSENCE,
		recipe: [TYPE.MAGIC, TYPE.SAND, TYPE.FOOD, TYPE.SAND],
	},
	{
		id: 40109,
		name: 'Stone Recovery',
		type: TYPE.RECOVERY,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40021,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.MAYA_ESSENCE,
		recipe: [TYPE.MAGIC, TYPE.BEAST, TYPE.WOOD, TYPE.FOOD],
	},
	{
		id: 40110,
		name: 'Sleep Recovery',
		type: TYPE.RECOVERY,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40021,
		element: ELEMENT.AIR,
		catalyst: CATALYST.MAYA_ESSENCE,
		recipe: [TYPE.MAGIC, TYPE.WOOD, TYPE.MAGIC, TYPE.SAND],
	},
	{
		id: 40111,
		name: 'Frozen Recovery',
		type: TYPE.RECOVERY,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40021,
		element: ELEMENT.WATER,
		catalyst: CATALYST.MAYA_ESSENCE,
		recipe: [TYPE.MAGIC, TYPE.MAGIC, TYPE.FOOD, TYPE.FOOD],
	},
	{
		id: 40112,
		name: 'Flame Disguise',
		type: TYPE.TRANSFIGURE,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40022,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.MISTRESS_ESSENCE,
		recipe: [TYPE.MAGIC, TYPE.BEAST, TYPE.WOOD, TYPE.MAGIC],
	},
	{
		id: 40113,
		name: 'Nature Disguise',
		type: TYPE.TRANSFIGURE,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40022,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.MISTRESS_ESSENCE,
		recipe: [TYPE.MAGIC, TYPE.ALLOY, TYPE.SAND, TYPE.BEAST],
	},
	{
		id: 40114,
		name: 'Rider Disguise',
		type: TYPE.TRANSFIGURE,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40022,
		element: ELEMENT.AIR,
		catalyst: CATALYST.MISTRESS_ESSENCE,
		recipe: [TYPE.MAGIC, TYPE.BEAST, TYPE.ALLOY, TYPE.ALLOY],
	},
	{
		id: 40115,
		name: 'Aqua Disguise',
		type: TYPE.TRANSFIGURE,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40022,
		element: ELEMENT.WATER,
		catalyst: CATALYST.MISTRESS_ESSENCE,
		recipe: [TYPE.MAGIC, TYPE.MAGIC, TYPE.MAGIC, TYPE.BEAST],
	},
	{
		id: 40116,
		name: 'Passion',
		type: TYPE.CREATION,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40023,
		element: ELEMENT.FIRE,
		catalyst: CATALYST.GARM_ESSENCE,
		recipe: [TYPE.MAGIC, TYPE.FOOD, TYPE.WOOD, TYPE.ALLOY],
	},
	{
		id: 40117,
		name: 'Vessel',
		type: TYPE.CREATION,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40023,
		element: ELEMENT.EARTH,
		catalyst: CATALYST.GARM_ESSENCE,
		recipe: [TYPE.MAGIC, TYPE.SAND, TYPE.FOOD, TYPE.ALLOY],
	},
	{
		id: 40118,
		name: 'Insight',
		type: TYPE.CREATION,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40023,
		element: ELEMENT.AIR,
		catalyst: CATALYST.GARM_ESSENCE,
		recipe: [TYPE.MAGIC, TYPE.MAGIC, TYPE.ALLOY, TYPE.FOOD],
	},
	{
		id: 40119,
		name: 'Heartplace',
		type: TYPE.CREATION,
		minQuality: 65,
		minScore: 200,
		base: BASE.BERSERK,
		specificMain: 40023,
		element: ELEMENT.WATER,
		catalyst: CATALYST.GARM_ESSENCE,
		recipe: [TYPE.MAGIC, TYPE.BEAST, TYPE.MAGIC, TYPE.BEAST],
	},
];

export const products = [
	...productsBasic,
	...productsIntermediate,
	...productsAdvanced,
];
